import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 px-4 sm:px-6 bg-cream" data-id="element-66" data-mp="1o3x1pk7r0m0y">
      <div className="max-w-2xl mx-auto bg-white border border-gold/40 p-5 sm:p-7 rounded-xl text-center shadow-sm" data-id="element-67" data-mp="1o3dnoel7yhs7">
        <p className="text-[11px] sm:text-sm font-heading font-bold text-sage uppercase tracking-widest mb-3" data-id="element-68" data-mp="22128jmfadox9">
          Il Tuo Acquisto è Protetto al 100%
        </p>
        <div className="w-14 h-14 mx-auto bg-sage/10 rounded-full flex items-center justify-center mb-3 border border-sage/20" data-id="element-69" data-mp="19fae6v7ywnyn">
          <ShieldCheckIcon className="w-7 h-7 text-sage" data-id="element-70" data-mp="14dteh317z7jn" />
        </div>
        <h3 className="text-lg sm:text-2xl font-heading font-extrabold text-petrol mb-3 leading-tight" data-id="element-71" data-mp="1j6501yhaxljk">
          🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni
        </h3>
        <p className="text-[13px] sm:text-base text-warmgray leading-relaxed mb-2" data-id="element-72" data-mp="qn7vlebrmxlr">
          Il tuo acquisto è completamente senza rischi. Hai 14 giorni per
          esplorare tutti i moduli, utilizzare le sessioni, i programmi, le
          valutazioni, le pianificazioni e gli strumenti professionali inclusi in
          SENIOR FITNESS COACH PRO™.
        </p>
        <p className="text-[13px] sm:text-base text-warmgray leading-relaxed" data-id="element-73" data-mp="ypl0rf400z5n">
          Se per qualsiasi motivo non sarai completamente soddisfatto, ti basterà
          contattarci entro 14 giorni e riceverai il rimborso completo.{' '}
          <span className="font-bold text-petrol" data-id="element-74" data-mp="61yyca6ic0kd">
            Nessun rischio. Nessuna domanda.
          </span>
        </p>
      </div>
    </section>;
}